module.exports = __webpack_public_path__ + "img/image-02.c0ece487.jpeg";